import { render, staticRenderFns } from "./Registro_Laboratorio_kiosko.vue?vue&type=template&id=4c92f51c&"
import script from "./Registro_Laboratorio_kiosko.vue?vue&type=script&lang=js&"
export * from "./Registro_Laboratorio_kiosko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports